export const selectModels = (state) => state.models;

export const selectModelPagedList = (state) => state.models.list;
export const selectModelPagedListLoading = (state) => state.models.loading;
export const selectModelPagedListLoadingCount = (state) => state.models.loadingCount;
export const selectModelPagedListError = (state) => state.models.error;
export const selectModelFilters = (state) => state.models.filters;